const heading = {
  baseStyle: {
    fontWeight: 500,
  },
  sizes: {},
  variants: {},
  defaultProps: {},
}

export default heading
